import { render, staticRenderFns } from "./PwaInstallPrompt.vue?vue&type=template&id=80890726&scoped=true"
import script from "./PwaInstallPrompt.vue?vue&type=script&lang=js"
export * from "./PwaInstallPrompt.vue?vue&type=script&lang=js"
import style0 from "./PwaInstallPrompt.vue?vue&type=style&index=0&id=80890726&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80890726",
  null
  
)

export default component.exports